"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), !function(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: !0,
        get: all[name]
    });
}(exports, {
    AssertionFailure: function() {
        return AssertionFailure;
    },
    empty: function() {
        return empty;
    },
    mustExist: function() {
        return mustExist;
    },
    notEmpty: function() {
        return notEmpty;
    }
});
const _Format = require("./Format");
class AssertionFailure extends Error {
    constructor(...args){
        super((0, _Format.format)(args));
    }
}
function mustExist(value, message) {
    if (notEmpty(value)) return value;
    throw new AssertionFailure(message || 'Value is expected but got none.');
}
function notEmpty(value) {
    return !empty(value);
}
function empty(value) {
    return null == value;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL0Fzc2VydC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBmb3JtYXQgfSBmcm9tICcuL0Zvcm1hdCdcblxuLyoqXG4gKiBBIGN1c3RvbSBlcnJvciB0aGF0IHJlcHJlc2VudHMgYW4gYXNzZXJ0aW9uIGZhaWxlZC4gVGFrZXMgYSBsaXN0IG9mIG9iamVjdHMgdG8gb3V0cHV0LCB3aGljaFxuICogYXJlIGZvcm1hdHRlZCB0aGUgc2FtZSB3YXkgYXMgYGNvbnNvbGUuZXJyb3IoKWAuXG4gKi9cbmV4cG9ydCBjbGFzcyBBc3NlcnRpb25GYWlsdXJlIGV4dGVuZHMgRXJyb3Ige1xuICAgIGNvbnN0cnVjdG9yKC4uLmFyZ3M6IHVua25vd25bXSkge1xuICAgICAgICBzdXBlcihmb3JtYXQoYXJncykpXG4gICAgfVxufVxuXG4vKipcbiAqIEEgaGVscGVyIHRvIGFzc2VydCB0aGF0IGEgbnVsbGFibGUgdmFsdWUgaGFzIGEgdmFsdWUuXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBtdXN0RXhpc3Q8VD4odmFsdWU6IFQgfCBudWxsIHwgdW5kZWZpbmVkLCBtZXNzYWdlOiBzdHJpbmcpOiBUIHtcbiAgICBpZiAobm90RW1wdHkodmFsdWUpKSByZXR1cm4gdmFsdWVcbiAgICB0aHJvdyBuZXcgQXNzZXJ0aW9uRmFpbHVyZShtZXNzYWdlIHx8ICdWYWx1ZSBpcyBleHBlY3RlZCBidXQgZ290IG5vbmUuJylcbn1cblxuLyoqXG4gKiBBIGhlbHBlciB0byBhc3NlcnQgdGhhdCBhIHZhbHVlIGlzIG5vdCBudWxsIG9yIHVuZGVmaW5lZCwgZm9yIGV4YW1wbGU6XG4gKiAgIGNvbnN0IGFycmF5OiAoc3RyaW5nIHwgbnVsbClbXSA9IFsnZm9vJywgbnVsbCwgJ2JhciddXG4gKiAgIGNvbnN0IGZpbHRlcmVkOiBzdHJpbmdbXSA9IGFycmF5LmZpbHRlcihub3RFbXB0eSlcbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIG5vdEVtcHR5PFQ+KHZhbHVlOiBUIHwgbnVsbCB8IHVuZGVmaW5lZCk6IHZhbHVlIGlzIFQge1xuICAgIHJldHVybiAhZW1wdHk8VD4odmFsdWUpXG59XG5cbi8qKlxuICogQSBoZWxwZXIgdG8gYXNzZXJ0IHRoYXQgYSB2YWx1ZSBpcyBudWxsIG9yIHVuZGVmaW5lZC5cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGVtcHR5PFQ+KFxuICAgIHZhbHVlOiBUIHwgbnVsbCB8IHVuZGVmaW5lZCxcbik6IHZhbHVlIGlzIG51bGwgfCB1bmRlZmluZWQge1xuICAgIHJldHVybiB2YWx1ZSA9PSBudWxsXG59XG4iXSwibmFtZXMiOlsiQXNzZXJ0aW9uRmFpbHVyZSIsImVtcHR5IiwibXVzdEV4aXN0Iiwibm90RW1wdHkiLCJFcnJvciIsImNvbnN0cnVjdG9yIiwiYXJncyIsImZvcm1hdCIsInZhbHVlIiwibWVzc2FnZSJdLCJyYW5nZU1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyIsIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7SUFNYUEsZ0JBQWdCO2VBQWhCQTs7SUEwQkdDLEtBQUs7ZUFBTEE7O0lBakJBQyxTQUFTO2VBQVRBOztJQVVBQyxRQUFRO2VBQVJBOzs7d0JBekJPO0FBTWhCLE1BQU1ILHlCQUF5Qkk7SUFDbENDLFlBQVksR0FBR0MsSUFBZSxDQUFFO1FBQzVCLEtBQUssQ0FBQ0MsSUFBQUEsY0FBTSxFQUFDRDtJQUNqQjtBQUNKO0FBS08sU0FBU0osVUFBYU0sS0FBMkIsRUFBRUMsT0FBZTtJQUNyRSxJQUFJTixTQUFTSyxRQUFRLE9BQU9BO0lBQzVCLE1BQU0sSUFBSVIsaUJBQWlCUyxXQUFXO0FBQzFDO0FBT08sU0FBU04sU0FBWUssS0FBMkI7SUFDbkQsT0FBTyxDQUFDUCxNQUFTTztBQUNyQjtBQUtPLFNBQVNQLE1BQ1pPLEtBQTJCO0lBRTNCLE9BQU9BLEFBQVMsUUFBVEE7QUFDWCJ9